import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import socket from '../socket.js';
import { useAuth } from './auth-provider/AuthJwtProvider';
import { useNotifications } from './notificationContext.jsx';

const SocketProvider = ({ children }) => {
  const { sessionUser } = useAuth();

  const { addNotification } = useNotifications();

  useEffect(() => {
    if (!sessionUser?._id) {
      console.log('⛔ socket NOT connecting because user not ready');
      return;
    }

    // ✅ Connect socket
    console.log('✅ Connecting socket now...');
    socket.connect();

    // ✅ Register ONLY after connection confirmed
    socket.on('connect', () => {
      console.log('✅ Socket connected:', socket.id);
      socket.emit('register', sessionUser._id);
    });

    // ✅ Listen for notifications
    socket.on('new_notification', (notif) => {
      console.log('🔔 New Notification:', notif);
      enqueueSnackbar(notif.message, {
        variant: 'info',
        autoHideDuration: 3000,
      });
      addNotification(notif);
    });

    // ✅ Optional: debug disconnects
    socket.on('disconnect', (reason) => {
      console.log('❌ Socket disconnected:', reason);
    });

    return () => {
      // ✅ Clean up ALL listeners on logout / unmount
      socket.off('connect');
      socket.off('new_notification');
      socket.off('disconnect');

      // ✅ Properly disconnect socket on logout
      socket.disconnect();
    };
  }, [sessionUser?._id]);

  return children;
};

export default SocketProvider;
